export default __webpack_public_path__ + "static/media/acoso-laboral.644a5356.png";